import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import './App.css';

const server_url = 'https://autoupdate.ukbd.app';

const formatDate = (isoString) => {
  if (!isoString) return "N/A"; // Handle missing dates

  const date = new Date(isoString);

  // Format in 12-hour format with AM/PM
  const options = {
    hour: '2-digit',
    minute: '2-digit',
    // second: '2-digit',
    hour12: true, // Use 12-hour format
    // weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };

  return date.toLocaleString('en-US', options); // Adjust based on your locale
};


function App() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [clients, setClients] = useState([]);
  const [search, setSearch] = useState('');
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState('asc');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const isAuthenticated = () => !!localStorage.getItem('token');

  useEffect(() => {
    if (isAuthenticated()) {
      fetchClients();
    }
  }, []);
  const highlightText = (text) => {
    if (!search || !text) return text;
    const regex = new RegExp(`(${search})`, 'gi');
    return text.replace(regex, (match) => `<span class="highlight">${match}</span>`);
  };

  const fetchClients = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${server_url}/clients`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setClients(response.data);
    } catch (error) {
      console.error('Error fetching clients:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(`${server_url}/login`, { username, password });
      // Get the current time (in milliseconds)
    const currentTime = new Date().getTime();

    // Assuming the token expires in 1 hour (3600000 milliseconds)
    const expirationTime = currentTime + 3600000;
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('name', username);
      localStorage.setItem("tokenExpiration", expirationTime);
      setTimeout(handleLogout, 3600000); 
      fetchClients();
      navigate("/");
    } catch (error) {
      setMessage('Invalid credentials!');
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async (client, usenpm) => {
    let clientId = client.id;
    const isConfirmed = window.confirm(`Are you sure you want to update ${client.name}?`);
    if (!isConfirmed) return; // If the user cancels, exit the function
  
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const user_name = localStorage.getItem("name");
      const response = await axios.post(
        `${server_url}/update-client`,
        { clientId, usenpm, user_name },
        { headers: { Authorization: `Bearer ${token}` } }
      );
  
      alert(response.data.message);
      fetchClients(); // Refresh data after update
      window.location.reload();
    } catch (error) {
      // console.log(error.response.data)
      alert(error.response.data.error2);
      window.location.reload();
    } finally {
      setLoading(false);
    }
  };
  

  const handleLogout = () => {
    // Get the current time and token expiration time from localStorage
    const currentTime = new Date().getTime();
    const tokenExpiration = localStorage.getItem("tokenExpiration");
  
    if (currentTime >= tokenExpiration) {
      // If the token has expired, perform logout automatically
      alert("Session expired, logging out...");
    }
  
    // Remove token and other data
    localStorage.removeItem("token");
    localStorage.removeItem("name");
    localStorage.removeItem("tokenExpiration");
  
    // Clear clients data
    setClients([]);
  
    // Redirect to login page
    navigate("/login"); 
  };
  

  const handleSearch = (e) => {
    setSearch(e.target.value.toLowerCase());
  };

  const handleSort = (field) => {
    const order = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';
    setSortField(field);
    setSortOrder(order);
  };

  const filteredClients = clients.filter(client =>
    client.name.toLowerCase().includes(search) ||
    client.status?.toLowerCase().includes(search) ||
    client.last_updated_by?.toLowerCase().includes(search)
  );

  const sortedClients = [...filteredClients].sort((a, b) => {
    if (!sortField) return 0;
  
    let valA = a[sortField];
    let valB = b[sortField];
  
    // Convert undefined/null values to empty strings to avoid errors
    valA = valA ? valA.toString() : '';
    valB = valB ? valB.toString() : '';
  
    return sortOrder === 'asc' ? valA.localeCompare(valB) : valB.localeCompare(valA);
  });

  return (
    <div>
      {!isAuthenticated() ? (
        <div className="login-container">
          <h2>Login</h2>
          <form onSubmit={handleSubmit}>
            <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} required placeholder="Username" />
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="Password" />
            <button type="submit">Login</button>
          </form>
          {message && <p>{message}</p>}
        </div>
      ) : (
        <div className="dashboard-container">
          <h2>Update Live Applications</h2>
          <p className="floatright width100">USER:: {`${localStorage.getItem('name')}`} </p>
          <button onClick={handleLogout} className="forcebtn marginbottom10 floatright">Logout</button>
          
          {/* Search Bar */}
          <input type="text" placeholder="Search clients..." value={search} onChange={handleSearch} className="search-input" />

          <table>
            <thead>
              <tr>
                <th onClick={() => handleSort('id')}>ID {sortField === 'id' ? (sortOrder === 'asc' ? '⬆' : '⬇') : ''}</th>
                <th onClick={() => handleSort('name')}>URL {sortField === 'name' ? (sortOrder === 'asc' ? '⬆' : '⬇') : ''}</th>
                <th onClick={() => handleSort('status')}>Status {sortField === 'status' ? (sortOrder === 'asc' ? '⬆' : '⬇') : ''}</th>
                <th onClick={() => handleSort('last_update')}>Last updated {sortField === 'last_update' ? (sortOrder === 'asc' ? '⬆' : '⬇') : ''}</th>
                <th onClick={() => handleSort('last_updated_by')}>Last updated by {sortField === 'last_updated_by' ? (sortOrder === 'asc' ? '⬆' : '⬇') : ''}</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {sortedClients.map((client) => (
                <tr key={client.id}>
                  <td dangerouslySetInnerHTML={{ __html: highlightText(client.id.toString()) }} />
                  <td><Link to={client.name.startsWith("http") ? client.name : `/${client.name}`} dangerouslySetInnerHTML={{ __html: highlightText(client.name) }} /></td>
                  <td dangerouslySetInnerHTML={{ __html: highlightText(client.status || 'Active') }} />
                  <td dangerouslySetInnerHTML={{ __html: highlightText(formatDate(client.last_update)) }} />
                  <td dangerouslySetInnerHTML={{ __html: highlightText(client.last_updated_by || 'Admin') }} />
                  <td className='btngrp'>
                    <button onClick={() => handleUpdate(client, 'no')}>Update</button>
                    <button className="forcebtn" onClick={() => handleUpdate(client, 'yes')}>Force Update</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {loading && <div className="loading-popup"><div className="spinner"></div><p>Loading...</p></div>}
    </div>
  );
}

export default App;
